import {
  Button,
  Container,
  Details,
  ScifiPanel,
  SectionTitle,
  SupportButton,
  UserInfo,
} from '@sloyd/ui';
import { api, plan } from './ContentAccount.data';
import { Actions, Content, Main, Side, Support, Wrapper } from './ContentAccount.style';

export type ContentAccountProps = {
  user: IUser;
  account: Json;
  isPaddlePortalLoading: boolean;
  callbacks: {
    onChange: (_change: Json, allData: Json) => void;
    onNavigate: (path: string) => void;
    buy10Credits: () => void;
    onPaddlePortal: () => void;
  };
};

export function ContentAccount(props: ContentAccountProps) {
  const { account, user, isPaddlePortalLoading, callbacks } = props;
  const { isPayingUser } = user;

  function renderApiSection() {
    if (!isPayingUser) return null;

    return (
      <ScifiPanel header='API'>
        <Details config={api.config} values={account.api} />
      </ScifiPanel>
    );
  }

  return (
    <Wrapper className='ContentAccount-wrapper' data-testid='ContentAccount-wrapper'>
      <Container size='md'>
        <SectionTitle gradient={{ from: '#ff6a00', to: '#ee0979' }} title='Account'>
          Manage your <strong>account</strong> here.
        </SectionTitle>

        <Content>
          <Main>
            <ScifiPanel header='Credits'>
              <Details config={plan.config} values={account.plan} />
            </ScifiPanel>
            {renderApiSection()}
          </Main>
          <Side>
            <UserInfo user={user} />
            <br />
            <Actions>
              <Button onClick={callbacks.buy10Credits} variant='light' disabled={!isPayingUser}>
                Buy more credits
              </Button>
              <Button
                variant='light'
                disabled={!isPayingUser}
                loading={isPaddlePortalLoading}
                onClick={callbacks.onPaddlePortal}
              >
                Manage Subscription
              </Button>
              <Button variant='light' disabled={true}>
                Generate API key
              </Button>
            </Actions>
            <Support>
              <SupportButton onNavigate={callbacks.onNavigate} />
            </Support>
          </Side>
        </Content>
      </Container>
    </Wrapper>
  );
}

export default ContentAccount;
